import { getTenant } from './utils/helpers/urlManipulation';

type DefaultItemState = 'unplanned' | 'planned' | 'underway' | 'done';
type NotRequiredState = 'notRequired';
export type ItemState = DefaultItemState; // alias for backward compatibility
export type AllItemState = DefaultItemState | NotRequiredState;
// entity-specific state types
export type CCItemState = DefaultItemState | NotRequiredState;
export type TaskItemState = DefaultItemState | CCItemState;

export type ItemStatus = 'green' | 'yellow' | 'red';

export const itemModes = [
  'unplanned',
  'planned',
  'underway',
  'underway-green',
  'underway-yellow',
  'underway-red',
  'done',
  'notRequired',
] as const;

export type ItemMode = (typeof itemModes)[number];

export function getItemMode(
  state: AllItemState,
  status?: ItemStatus,
): ItemMode {
  if (state !== 'underway' || !status) {
    return state as ItemMode;
  }

  return (state + '-' + status) as ItemMode;
}

const defaultItemModes = itemModes.filter((mode) => mode !== 'notRequired');

export function useItemModeOptions(
  $t: (key: string) => string,
  entityType: 'default' | 'cc' = 'default',
) {
  function getLanguageKey(option: string) {
    if (option.startsWith('underway')) {
      return 'inProgress';
    }
    if (option === 'notRequired') {
      return 'notRequired';
    }

    return option;
  }

  const isUnavailable = (mode: string) => isTraffic() && mode === 'underway';

  const availableModes = entityType === 'cc' ? itemModes : defaultItemModes;

  const modeOptions = computed(() =>
    availableModes
      .filter((value) => !isUnavailable(value))
      .map((value) => ({
        label: $t(`statusBadges.${getLanguageKey(value)}`),
        value: value as ItemMode,
      })),
  );

  return { modeOptions };
}

export function isTraffic(): boolean {
  return import.meta.env[`VITE_${getTenant()}_traffic_light`] === '1';
}
